import { Injectable } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import {
  ITrackingConfiguration,
  ITrackingConfigurationService,
} from '@nimbus-library/features/tracking/services/i-tracking-configuration.service';

@Injectable()
export class TrackingConfigurationService implements ITrackingConfigurationService {
  public get configuration(): ITrackingConfiguration {
    return {
      tenantUUID: this.environmentConfigurationService.configurationSettings.planHatTenantUUID,
      module: 'Assistant',
    };
  }
  public constructor(private readonly environmentConfigurationService: EnvironmentConfigurationService) {}
}
